import {Component, OnInit} from '@angular/core';
import {routerTransition, slideToLeft} from "../../../animations/router.animations";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PopupComponent} from "../../../shared/popup/popup.component";
import {NewUserService} from "../../../service/sell/newUser.service";
import {formatNumber,formatCurrency} from '@angular/common';
import {LoaderService} from "../../../service/loader.service";
import {PHONE_MASK} from "../../../config/country_phone_mask";
import {PhoneMaskService} from "../../../service/phoneMask.service";
import {ActivatedRoute, Params} from "@angular/router";
import {GamesProviderService} from "../../../service/game/gamesProvider.service";
import {PartnerService} from "../../../service/partner.service";

@Component({
    selector: 'app-new-user',
    templateUrl: './new-user.component.html',
    styleUrls: ['./new-user.component.scss'],
    // animations: [routerTransition('left')],
    // host: {'[@routerTransition]': ''}
    animations: [slideToLeft],
    host: {'[@slideToLeft]': ''}
})
export class NewUserComponent implements OnInit {
    newUserForm: FormGroup;
    phoneMask = this.phoneMaskService.setPhoneMask();

    singleGame;

    gameId;
    isRiverPay = this.partnerService.isRiverPay();

    constructor(private formBuilder: FormBuilder,
                private newUserService: NewUserService,
                private loaderService: LoaderService,
                private phoneMaskService: PhoneMaskService,
                private route: ActivatedRoute,
                private partnerService: PartnerService,
                private gameProviderService: GamesProviderService,
                private popupComponent: PopupComponent,) {

    }

    ngOnInit() {
        this.newUserForm = this.formBuilder.group({
            phone: [null, Validators.required],
            amount: [null],
            // usdc_amount: [null]
        });

        this.route.params.subscribe((params: Params) => {
            this.gameId = params.gameId;
        });

        this.route.queryParams.subscribe(params => {
            this.singleGame = params.single;
        });
    }

    onSubmit() {
        const phone = this.newUserForm.controls.phone.value;
        const amount = this.newUserForm.controls.amount.value;
        // const usdc_amount = this.newUserForm.controls.usdc_amount.value;
        //const text = this.isRiverPay ? `${phone} <br><br> Please confirm ${formatCurrency(amount, 'en','$')} contribution toward Cross 10K Gold Pen` : `${phone} <br><br> Membership/Sweeps: $${formatNumber(amount, 'en-US')}<br><br> USDC: $${formatNumber(usdc_amount, 'en-US')}`;
        const text = this.isRiverPay ? `${phone} <br><br> Please confirm ${formatCurrency(amount, 'en','$')} contribution toward Cross 10K Gold Pen` : `${phone} <br><br> Membership/Sweeps: $${formatNumber(amount, 'en-US')}<br>`;

        this.popupComponent.showPopupAgreement({text: text,
            confirmButtonText: 'CONFIRM<svg><rect></rect></svg>',
            cancelButtonText: '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                              '<path d="M25.5 24.1719L18.3281 17L25.5 9.82812C25.8668 9.46136 25.8668 8.86676 25.5 8.5C25.1332 8.13324 24.5386 8.13324 24.1719 8.5L17 15.6719L9.82813 8.5C9.46136 8.13324 8.86676 8.13324 8.5 8.5C8.13324 8.86676 8.13324 9.46136 8.5 9.82812L15.6719 17L8.5 24.1719C8.13324 24.5386 8.13324 25.1332 8.5 25.5C8.86676 25.8668 9.46136 25.8668 9.82813 25.5L17 18.3281L24.1719 25.5C24.5386 25.8668 25.1332 25.8668 25.5 25.5C25.8668 25.1332 25.8668 24.5386 25.5 24.1719Z" fill="#FDFD88"/>\n' +
                              '</svg>'}, (status) => {
            if (status) {
                this.submit();
            }
        });
    }

    submit() {
        const phone = this.newUserForm.controls.phone.value.replace(/\D+/g, '');
        const amount = this.newUserForm.controls.amount.value ? this.newUserForm.controls.amount.value : 0;
        const usdc_amount = 0;
        const gameId = this.gameId;

        this.loaderService.show();
        this.newUserService.sell(phone, amount, usdc_amount, gameId).subscribe(data => {
            this.loaderService.hide();
            if(data.status){
                this.popupComponent.showPopupSuccess({text:data.message});
                this.newUserForm.reset();
            } else {
                this.popupComponent.showPopupError({text:data.message});
            }
        });
    }

    getGameProviderName() {
        return this.gameProviderService.getGameProviderName();
    }

    getBackLink() {
        if (this.singleGame === 'true') {
            return `/home/sell`;
        } else {
            return `/home/sell/games-providers/new-user`;
        }
    }

}
